import React from 'react';
import Label from '../atoms/Label';
import Button from '../atoms/Button';

export default ({ label, text, labelregular, textbold, col, onClick, url, isDisabled }) => {
  let colLabel = 'col-md-6'
  let colText = 'col-md-6'
  if( col ){
    colLabel = col.label
    colText = col.text
  }
  return(

    <div className='row container-label-with-text'>
      <div className={ colLabel +' text-left' }>
        {
          labelregular ? (
            <Label value={ label } className='color-text-label label-kc-s'/>
          ) : (
            <Label value={ label } className='color-text-label label-kc-sb'/>
          )
        }
      </div>
      <div className={ colText + ' text-left' }>
				{/* <Button title={'Lihat'} type={'button'} color="blue" width="small" /> */}
				<Button title={'Lihat'} isDisabled={isDisabled} type={'button'} color="blue" width="small" onClick={onClick} url={url} />

      </div>
    </div>
  )
}